import ForeignKeyRenderer from './ForeignKeyRenderer';

const renderer = new ForeignKeyRenderer();

class DrilldownOption {
  constructor(type, data) {
    this._type = type; // string ('underlying' or 'fk')
    this._data = data; // data needed by server to perform this drilldown
  }

  type() {
    return this._type;
  }

  data() {
    return this._data;
  }

  static sortFunc(o1, o2) {
    if (o1.type() === 'underlying' && o2.type() === 'underlying') {
      return 0;
    }
    if (o1.type() === 'underlying') {
      return -1;
    }
    if (o2.type() === 'underlying') {
      return 1;
    }
    const fk1 = o1.data();
    const fk2 = o2.data();
    function fkSortString(fk) {
      return `${fk.foreignColumn().tov().name()} (${fk.foreignColumn().name()}`;
    }
    return fkSortString(fk1).localeCompare(fkSortString(fk2));
  }

  html() {
    switch (this.type()) {
      case 'underlying':
        return 'underlying rows';
      case 'fk':
        return renderer.renderValue(this.data());
      default:
        throw new Error(`unknown drilldown type:${this.type()}`);
    }
  }
}

export default DrilldownOption;
